<template>
  <div>
    <base-header class="pb-6 pb-8 pt-5 pt-md-8 bg-gradient-success">
      
    </base-header>
    <b-container fluid class="mt--7">
      <b-row>
        <b-col class="col-md-12 col-xl-12">
          <b-card
            title="Your donation was received successfully, THANK YOU!"
            img-src="img/thanks.jpg"
            img-alt="Image"
            img-bottom
            tag="article"
            style="max-width: 100%;"
            class="mb-2 mr-2"
          >
            <b-card-text class="text-sm">
              <i class="ni ni-check-bold text-green"></i>
              Thanks for supporting BitcoinMinds.org - world's largest database of Bitcoin resources.<br>
            </b-card-text>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>

  export default {
    components: {
    },
    data() {
      return {
      };
    }
  };
</script>
<style>
</style>
